import { css } from 'lit';

import { BREAKPOINT_SMALL_PX } from '@/settings';

export const quantityTableStyles = css`
  .quantities {
    width: 100%;
  }

  .quantities th,
  .quantities td {
    font-weight: 400;
    text-align: right;
    padding-right: 10px;
    padding-left: 10px;
  }

  .quantities th {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .quantities td {
    padding-top: 13px;
    padding-bottom: 13px;
  }

  .quantities th.amount,
  .quantities td.amount,
  .quantities th.size,
  .quantities td.size,
  .quantities th.color,
  .quantities td.color {
    text-align: left;
    padding-right: 0;
  }

  .quantities td.amount,
  .quantities td.color {
    padding-top: 4px;
    padding-bottom: 4px;
  }

  .quantities td.color {
    font-size: 0.875rem;
  }

  .quantities td.color .image {
    width: 50px;
    height: 50px;
    display: inline-block;
    vertical-align: middle;
  }

  .quantities td.color img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .quantities td.color span {
    display: none;
  }

  .quantities td.total-price {
    font-weight: 700;
  }

  .quantities tbody {
    background: #fff;
  }

  .quantities tbody tr td {
    border-bottom: 1px solid var(--fg-gray--300, var(--fg-fallback-gray--300));
  }

  .quantities tfoot tr td {
    background: #fff;
  }

  .quantities tfoot tr td:first-child {
    border-bottom-left-radius: var(
      --fg-borderradius,
      var(--fg-fallback-borderradius)
    );
  }

  .quantities tfoot tr td:last-child {
    border-bottom-right-radius: var(
      --fg-borderradius,
      var(--fg-fallback-borderradius)
    );
  }

  .quantities tfoot table {
    width: 100%;
  }

  .quantities tfoot table td {
    font-size: 0.875rem;
    text-align: left;
    height: auto;
    border: 0;
    padding: 0;
  }

  .quantities tfoot table tr:not(:first-child) td {
    padding-top: 10px;
  }

  .quantities tfoot table td:last-child {
    text-align: right;
  }

  .quantities tfoot table tr.setup-price td:last-child {
    font-weight: 700;
  }

  .quantities tfoot table tr.total td {
    font-size: 1rem;
    font-weight: 700;
    color: #000;
  }

  .quantities tfoot table tr.profit td em,
  .quantities tfoot table tr.profit td:last-child {
    color: var(--fg-cta, var(--fg-fallback-cta));
  }

  .quantities tfoot table tr.profit td:last-child {
    font-weight: 700;
  }

  @media screen and (min-width: ${BREAKPOINT_SMALL_PX}px) {
    .quantities th,
    .quantities td {
      padding-right: 20px;
      padding-left: 20px;
    }

    .quantities td {
      font-size: 1rem;
    }

    .quantities td.color img {
      margin-right: 4px;
    }

    .quantities td.color span {
      display: inline-block;
    }

    .quantities tfoot > tr > td {
      padding: 20px 20px 35px;
    }
  }
`;
